import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = auth
  const [error, setError] = useState("");

  const bootstrap = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const setFromResponse = (data) => {
    if (data.token) localStorage.setItem("bl_token", data.token);
    setUser(data);
  };

  const login = async (email, password) => {
    setError("");
    try { const r = await api.post("/auth/login", { email, password }); setFromResponse(r.data); return true; }
    catch (e) { setError(formatApiError(e)); return false; }
  };

  const register = async (name, email, password) => {
    setError("");
    try { const r = await api.post("/auth/register", { name, email, password }); setFromResponse(r.data); return true; }
    catch (e) { setError(formatApiError(e)); return false; }
  };

  const trialSignup = async (email) => {
    setError("");
    try { const r = await api.post("/auth/trial-signup", { email }); setFromResponse(r.data); return r.data; }
    catch (e) { setError(formatApiError(e)); return null; }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("bl_token");
    setUser(false);
  };

  const refresh = async () => {
    try { const r = await api.get("/auth/me"); setUser(r.data); return r.data; } catch { return null; }
  };

  return (
    <AuthContext.Provider value={{ user, login, register, trialSignup, logout, refresh, error, setError }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
